import script from "./DetailedInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailedInformation.vue?vue&type=script&setup=true&lang=js"

import "./DetailedInformation.vue?vue&type=style&index=0&id=afdc365c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afdc365c"]])

export default __exports__